import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'projects/store/src/environments/environment';
import { CountryCode } from 'projects/store/src/app/enums';
import { PhoneAppState, PhoneAppStatusService } from 'projects/store/src/app/services/api/v1/phone-app-status.service';

@Component({
  selector: 'app-sales-phone-nuovo-krdya-platform',
  templateUrl: './sales-phone-nuovo-krdya-platform.component.html'
})
export class SalesPhoneNuovoKrdyaPlatformComponent implements OnInit, OnDestroy {
  @Input() requestId!: string;
  @Input() otp?: string | null;
  @Output() nextStep = new EventEmitter<void>();

  appState: PhoneAppState = PhoneAppState.Waiting;
  visibleModal = false;

  private subscription?: Subscription;

  readonly isMexico = environment.global.country.code === CountryCode.MX;

  constructor(private status: PhoneAppStatusService) {}

  ngOnInit(): void {
    this.subscription = this.status.state$.subscribe(state => {
      const wasWaiting = this.appState === PhoneAppState.Waiting;
      this.appState = state;
      if (state === PhoneAppState.Ready && wasWaiting) {
        this.visibleModal = true;
      }
    });
    this.status.start(this.requestId);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.status.stop();
  }

  onContinue(): void {
    this.nextStep.emit();
  }

  downLoadApp(): void {
    window.open('https://play.google.com/store/search?q=krediya&c=apps&hl=es_419', '_blank');
  }

  get title(): string {
    return this.appState === PhoneAppState.Ready ? 'Registro finalizado' : 'Registro en progreso';
  }

  get subTitle(): string {
    return 'Para finalizar el registro en KRDYA, por favor ten a mano la cédula o teléfono del crédito y validar el OTP de firma';
  }
}
